import styled from 'styled-components';

export const ChartContainer = styled.div`
   width: 100%;
   background: ${({ theme }) => theme.colors.surface};
   border: 1px solid ${({ theme }) => theme.colors.border};
   border-radius: 12px;
   padding: 24px;
   margin-top: 20px;

   h3 {
      margin: 0 0 20px 0;
      font-size: 18px;
      color: ${({ theme }) => theme.colors.textPrimary};
   }

   .chart-wrapper {
      width: 100%;
      height: 400px;
      position: relative;

      @media (max-width: 768px) {
         height: 300px;
      }
   }

   .chart-empty {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 400px;
      color: ${({ theme }) => theme.colors.textMuted};
      font-size: 14px;
   }
`;

export const ChartLegend = styled.div`
   display: flex;
   gap: 20px;
   margin-top: 16px;
   padding-top: 16px;
   border-top: 1px solid ${({ theme }) => theme.colors.border};
   flex-wrap: wrap;
`;

export const LegendItem = styled.div`
   display: flex;
   align-items: center;
   gap: 8px;
   font-size: 13px;
   color: ${({ theme }) => theme.colors.textPrimary};

   .legend-color {
      width: 16px;
      height: 16px;
      border-radius: 3px;
      background: ${({ $color }) => $color || '#666'};
   }
`;
